<div class="sign-status-container">
  @if (preloader) {
    <libero-preload-spinner></libero-preload-spinner>
  } @else {
    @if (notFoundWithToken) {
      <p>{{ 'emailConfirm.notFoundWithToken' | translate }}</p>
    }
    @if (errored.apiCallFailed) {
      <p>{{ 'emailConfirm.apiErrored' | translate }}</p>
    }
    @if (errored.missingToken) {
      <p>{{ 'emailConfirm.missingToken' | translate }}</p>
    }
    @if (errored.reasoned) {
      <div class="error-header">
        <p>{{ 'emailConfirm.errorTexts.' + (regularWithdrawalConfirmFailed ? 'regularWithdrawal' : errored.reasoned) + '.header' | translate }}</p>
      </div>
      <div class="error-text">
        <p>{{ 'emailConfirm.errorTexts.' + (regularWithdrawalConfirmFailed ? 'regularWithdrawal' : errored.reasoned) + '.text' | translate }}</p>
      </div>
      <div class="error-footer">
        <p [innerHTML]="'emailConfirm.errorTexts.footerRow1' | translate"></p>
        <p [innerHTML]="'emailConfirm.errorTexts.footerRow2' | translate"></p>
      </div>
    } @else if (!isInError && !notFoundWithToken) {
      @if (isRegularWithdrawalConfirmed) {
        <p>{{ 'emailConfirm.successDipWithdrawalPart1' | translate }}</p>
        <p>{{ 'emailConfirm.successDipWithdrawalPart2' | translate }}</p>
      } @else {
        <p>{{ 'toastNotifications.messages.fallbackMailConfirm' | translate }}</p>
      }
    }
  }
</div>